import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import ApiService from '../../../../services/Api.js';
import { APP_CONFIG } from '../../../../utils/globales.js';
import '../../index.css';

// Componentes
import PaginaBiovert from '../../../../components/pagina-biovert';
import BreadCrumbBiovert from '../../../../components/breadcrumb-biovert';
import HeaderBiovert from '../../../../components/header-biovert';
import GreyboxBiovert from '../../../../components/greybox-biovert';
import SeccionAceptarCancelarBiovert from '../../../../components/seccion-aceptar-cancelar-biovert';

// Notificaciones
import { toast } from 'react-toastify';

// Fontawesome
import FontAwesome from 'react-fontawesome';

class ProductosGenericosAddPage extends Component {

    constructor (props) {
        super(props);
        this.state = {
            codigoDeArticulo: null,
            redirectId: null,
        };
    }

    handleChangeCodigoDeArticulo = event => {this.setState({ codigoDeArticulo: event.target.value });}

    guardaNuevoProductoGenerico = () => {

        // Comprobamos campo no vacio
        if (this.state.codigoDeArticulo == null
          || 0 >= this.state.codigoDeArticulo.length) return true;

        const requestData = {
            endpoint: APP_CONFIG.ENDPOINTS.PRODUCTOS_GENERICOS,
            method: 'POST',
            authorized: true,
            contentType: 'application/json',
            data: { codigo: this.state.codigoDeArticulo }
        };
        ApiService.request(requestData)
            .then((response) => {
                //toast.success(<div><FontAwesome name='check'/>&nbsp;<span>Producto guardado con éxito</span></div>);
                this.setState({
                    codigoDeArticulo: '',
                    redirectId: Number(JSON.parse(response).id),
                });
            })
            .catch((error) => {
                if (undefined === error.detail) toast.error(<div><FontAwesome name='times'/>&nbsp;<span>Se ha producido un error al guardar el producto genérico</span></div>);
                else toast.error(<div><FontAwesome name='times'/>&nbsp;<span>{error.detail}</span></div>);
                console.log('Error: ' + JSON.stringify(error));
            });

    };

    render() {

        // Redirect
        if (null !== this.state.redirectId) return (<Redirect to={APP_CONFIG.RUTAS.PRODUCTOS_EDIT + '/g/' + this.state.redirectId}/>);

        // Add
        return (
            <PaginaBiovert>
                <div className='producto-container'>
                    {/* Breadcrumb */}
                    <BreadCrumbBiovert value = {[ 'Productos genéricos', 'Nuevo' ]}/>
                    <HeaderBiovert type='t1'>Nuevo producto genérico</HeaderBiovert>
                    {/* Formulario */}
                    <GreyboxBiovert>
                        <div className='producto-formulario'>
                            <div className='producto-formulario-fila'>
                                <div className='producto-formulario-elemento'>
                                    <div className='producto-formulario-elemento-titulo'>Código de artículo</div>
                                    <div className='producto-formulario-elemento-contenido'>
                                        <input
                                            id='producto-generico-text-input'
                                            type='text'
                                            value={this.state.codigoDeArticulo || ''}
                                            onChange={this.handleChangeCodigoDeArticulo}
                                            className='producto-text-input'
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </GreyboxBiovert>
                    <SeccionAceptarCancelarBiovert onAccept={this.guardaNuevoProductoGenerico}/>
                </div>
            </PaginaBiovert>
        );
    }

}

export default ProductosGenericosAddPage;
